export const  defaultSelectedDateUp  = () => {
    const currentDate = new Date();
    const year = currentDate.getFullYear();
    const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
    const day = currentDate.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;
};

export const defaultSelectedDateFrom = () => {
    const oneMonthAgo = new Date();
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);
    const year = oneMonthAgo.getFullYear();
    const month = (oneMonthAgo.getMonth() + 1).toString().padStart(2, '0');
    const day = oneMonthAgo.getDate().toString().padStart(2, '0');
    return `${year}-${month}-${day}`;

};


export default {
    loading: {
        module: false
    },
    params: {
        dateUp : defaultSelectedDateUp(),
        dateFrom : defaultSelectedDateFrom(),
        voucherType_id: null,
        user_id: null,
    },
    voucherTypes: [],
    reportUserDocuments: [],
    users_select: [],
    users_params:{
        paginate: false,
        page: 1,
        perPage: 200,
        filter: '',
        sortBy: 'name',
        sort: 'ASC'
    },
    ag_grid:{
        selectedTheme:'ag-theme-balham'
    }
}



// WEBPACK FOOTER //
// ./src/modules/report-user-document/state.js